import React from "react";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { useHistory } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Auth from "src/auth";
import CIcon from "@coreui/icons-react";

const TheHeaderDropdown = (props) => {
  const { logout, authenticated } = Auth();
  const history = useHistory();
  return (
    <>
      <CDropdown
        inNav
        className=" c-header-nav-items mx-2 "
        variant="nav-item"
        alignment={{ xs: "end", lg: "start" }}
      >
        <CDropdownToggle className="c-header-nav-link mr-3  " caret={false}>
          <AccountCircleIcon />
          <span className="ml-1 mr-2">
            {/* {authenticated.role === "CGMF" ? "CGMFPED" : authenticated.role === "Bidder" ? } */}

            {!authenticated.username
              ? authenticated.role
              : authenticated.username}
          </span>
        </CDropdownToggle>
        <CDropdownMenu>
          {authenticated.role === "Bidder" && (
            <CDropdownItem
              onClick={() => {
                history.push("/profile");
              }}
            >
              <CIcon name="cil-user" />
              <span className="ml-1"> Profile</span>
            </CDropdownItem>
          )}
          <CDropdownItem
            onClick={() => {
              logout(() => {
                history.push("/login");
              });
            }}
          >
            <LogoutIcon />
            <span className="ml-1"> Log Out</span>
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    </>
  );
};

export default TheHeaderDropdown;
